// Thin client for the Express metadata proxy (/api/*) and contact endpoint.
// Same-origin in production; proxied to the Express server by Vite in dev.

export type Meta = {
  id: string;
  imdb_id?: string;
  name: string;
  type?: string;
  description?: string;
  releaseInfo?: string;
  imdbRating?: string;
  genres?: string[];
  runtime?: string;
  [key: string]: unknown;
};

async function getJson<T>(url: string): Promise<T> {
  const res = await fetch(url);
  const body = await res.json().catch(() => null);
  if (!res.ok) throw new Error((body && (body as { error?: string }).error) || 'Request failed');
  return body as T;
}

// /api/find and /api/search return {} on upstream failure — callers should guard with Array.isArray.
export const apiFind = (type: 'movie' | 'series', limit: number) =>
  getJson<Meta[] | Record<string, never>>(`/api/find?type=${type}&limit=${limit}`);

export const apiSearch = (q: string, limit = 12) =>
  getJson<Meta[] | Record<string, never>>(`/api/search?q=${encodeURIComponent(q)}&limit=${limit}`);

export const apiGet = (imdbId: string) =>
  getJson<Meta | Record<string, never>>(`/api/get?imdb_id=${encodeURIComponent(imdbId)}`);

export type ContactResult = {
  contact?: {
    success?: { header: string; text: string };
    err?: { header: string; text: string };
  };
};

export async function sendContact(name: string, mail: string, msg: string): Promise<ContactResult> {
  const body = new URLSearchParams({ name, mail, msg });
  const res = await fetch('/contact', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body,
  });
  return (await res.json()) as ContactResult;
}
